import dataList from './data-list';
import formArea from './form-area';
import formUpload from './form/form-upload';
import fileUpload from './form/file-upload';
import richEditor from './tiny-editor';
import vcolorpicker from 'vcolorpicker'
import tabBar from './ui/tab-bar';
import selectEntity from './form/select-entity';
import coordinatePicker from './form/coordinate-picker';
import timePeriod from './form/time-period';
import liveConfig from './live-config';
import tagList from './form/tag-list';
import numberRange from './form/number-range';
import lunarPicker from './form/lunar-picker'
import timeRange from "./form/time-range";
import moduleSetting from "./form/module-setting";
import giftList from "./form/gift-list";
import itemList from "./item-list";
import selectPerson from "./form/select-person";
import addPerson from "./form/add-person";
import sImg from "./s-img";
import clUpload from "./cl-upload";

const install = function (Vue) {
    Vue.component("dataList", dataList);
    Vue.component("formUpload", formUpload);
    Vue.component("fileUpload", fileUpload);
    Vue.component("richEditor", richEditor);
    Vue.component("selectEntity", selectEntity);
    Vue.component("coordinatePicker", coordinatePicker);
    Vue.component("timePeriod", timePeriod);
    Vue.component("liveConfig", liveConfig);
    Vue.component("tagList", tagList);
    Vue.component("numberRange", numberRange);
    Vue.component("timeRange", timeRange);
    Vue.component("lunarPicker", lunarPicker);
    Vue.component("itemList", itemList);
    Vue.component("selectPerson", selectPerson);
    Vue.component("moduleSetting", moduleSetting);
    Vue.component("giftList", giftList);
    Vue.component("addPerson", addPerson);
    Vue.component("formArea", formArea);
    Vue.component("tabBar", tabBar);
    Vue.component("sImg", sImg);
    Vue.component("clUpload", clUpload);
    Vue.component("Vnodes", {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes
    });
    Vue.use(vcolorpicker);
}

export default install;
